import { IExaminationOrganization } from "../models/examinationOrganization";

export const SET_EXAMINATION_ORGANIZATIONS = "SET_EXAMINATION_ORGANIZATIONS";

export const SetExaminationOrganizations = (payload: IExaminationOrganization[]) => {
    return { type: SET_EXAMINATION_ORGANIZATIONS, payload };
};